import { ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';
import { Application } from '@frontend/functionality/types';

import { TRANSACTION_VOLUME_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const PUDO_TRANSACTION_VOLUME_BAR_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.PUDO_TRANSACTION_VOLUME_BAR,
    chartType: ChartRendererType.BAR,
    endpoint: TRANSACTION_VOLUME_CHART_ENDPOINT,
    filters: [{ key: ChartQueryParam.APPLICATION, value: Application.PUDO }]
};
